var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8371 3.40827C12.8371 2.94608 12.4624 2.57141 12.0002 2.57141C11.538 2.57141 11.1634 2.94608 11.1634 3.40827V11.1632H3.40839C2.94621 11.1632 2.57153 11.5378 2.57153 12C2.57153 12.4622 2.94621 12.8369 3.40839 12.8369H11.1634V20.5917C11.1634 21.0539 11.538 21.4286 12.0002 21.4286C12.4624 21.4286 12.8371 21.0539 12.8371 20.5917V12.8369H20.5918C21.054 12.8369 21.4287 12.4622 21.4287 12C21.4287 11.5378 21.054 11.1632 20.5918 11.1632H12.8371V3.40827Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.73f9f400fa355518fa6eef011b4494a8.svg";
export { ForwardRef as ReactComponent };